{
  "previous": "Sebelumnya",
  "next": "Berikutnya",
  "complete": "Selesai",
  "verifyAndCheckIn": "Verifikasi dan check-in",
  "loading": {
    "retrievingLocation": "Mengambil lokasi...",
    "retrievingWarehouse": "Mengambil data gudang..."
  },
  "validation": {
    "fieldRequired": "Kolom ini wajib diisi",
    "fieldRequiredWithLabel": "{label} wajib diisi",
    "phoneInvalid": "Nomor telepon tidak valid",
    "phoneInvalidWithExample": "Nomor telepon tidak valid (contoh: {example})"
  }
}
